import { DRAWING_TOOL } from "../../engine/drawings/drawingTools";

/** Tools of the menu in the order of PO (research §1.5) with their translation keys. */
export const DRAWING_MENU_TOOLS = [
  { id: DRAWING_TOOL.HORIZONTAL_LINE, labelId: "futures.chart.drawings.tool_horizontal_line" },
  { id: DRAWING_TOOL.VERTICAL_LINE, labelId: "futures.chart.drawings.tool_vertical_line" },
  { id: DRAWING_TOOL.RAY, labelId: "futures.chart.drawings.tool_ray" },
  { id: DRAWING_TOOL.FIBONACCI_RETRACEMENT, labelId: "futures.chart.drawings.tool_fibonacci_retracement" },
  { id: DRAWING_TOOL.FIBONACCI_FAN, labelId: "futures.chart.drawings.tool_fibonacci_fan" },
  { id: DRAWING_TOOL.TREND_LINE, labelId: "futures.chart.drawings.tool_trend_line" },
  { id: DRAWING_TOOL.PARALLEL_CHANNEL, labelId: "futures.chart.drawings.tool_parallel_channel" },
  { id: DRAWING_TOOL.RECTANGLE, labelId: "futures.chart.drawings.tool_rectangle" },
  { id: DRAWING_TOOL.ANDREWS_PITCHFORK, labelId: "futures.chart.drawings.tool_andrews_pitchfork" },
];

/**
 * @param {string} toolId - DRAWING_TOOL value
 * @returns {string} translation key of the tool name
 */
export const drawingToolLabelId = (toolId) => DRAWING_MENU_TOOLS.find(({ id }) => id === toolId).labelId;
